import FormFieldLoadingPlaceholder from "@/app/_components/forms/FormFieldLoadingPlaceholder";

const ContactFormLoadingPlaceholder = () => {
	return (
		<div className="flex w-full max-w-2xl flex-col gap-4">
			<FormFieldLoadingPlaceholder />
			<FormFieldLoadingPlaceholder />
			<FormFieldLoadingPlaceholder />
			<FormFieldLoadingPlaceholder />
		</div>
	);
};

export default ContactFormLoadingPlaceholder;
